import script from "./giftadd.vue?vue&type=script&setup=true&lang=js"
export * from "./giftadd.vue?vue&type=script&setup=true&lang=js"

import "./giftadd.vue?vue&type=style&index=0&id=72017620&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72017620"]])

export default __exports__